import React from "react";

export const handleGoToURL = (event, that, url) => {
    event.preventDefault();

    that.props.history.push(url);//event.currentTarget.getAttribute("href"));
}



// WEBPACK FOOTER //
// ./src/utils/URL.js